// base
import React, { Component } from "react";

// assets
import "./main.scss";

// components
import {
  Layout,
  PageState,
  Search,
  ContentsBox,
  BlockTime,
  BlocksComponent,
  TransactionsComponent,
  Responsive,
  Button,
  TopBalanceComponent,
} from "../../components";
import ReactTooltip from "react-tooltip";
import { toFixed } from "../../../helper";

// api
import { miners, recently, topRank, totalBalance } from "../../../api";
import con from "../../../constants";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import produce from "immer";
import { mainnet, testnet, devnet } from "../../../modules/appState";
// import TopBalanceComponent from "../../components/TopBalance/TopBalanceComponent";

class Main extends Component {
  state = {
    miners: {},
    blocks: [],
    txs: [],
    recentBlocks: [],
    topRanks: [],
    totalBalance: 0,
    totalAccounts: 0,
  };

  getHeartBeat = () => {
    if (this.webSock.readyState !== 0) {
      this.webSock.send("heartbeat");
    }
  };

  getMiners = async () => {
    try {
      let res = await miners(this.props.network);
      if (res.status === 200) {
        this.setState({
          miners: res.data.miners,
        });
      }
    } catch (e) {
      console.log(e);
    }
  };

  getRecent = async () => {
    try {
      let res = await recently(this.props.network);
      if (res.status === 200) {
        let txs = res.data.transactions;
        this.setState({
          blocks: res.data.blocks,
          txs: txs.length > 10 ? txs.slice(0, 10) : txs,
        });
      }
    } catch (e) {
      console.log(e);
    }
  };

  getTotalBalance = async () => {
    try {
      let res = await totalBalance(this.props.network);
      if (res.status === 200) {
        this.setState({
          totalBalance: res.data.TotalBalance,
          totalAccounts: res.data.Accounts,
        });
      }
    } catch (e) {
      console.log(e);
    }
  };

  getTopRanks = async () => {
    try {
      let res = await topRank(1, 5);
      if (res.status === 200) {
        let lists = res.data.list;
        this.setState({
          topRanks: lists,
        });
      }
    } catch (e) {
      console.log(e);
    }
  };

  openWebSocket = () => {
    this.closeWebSocket();
    // 사용하지않음으로 주석처리
    // this.getMiners();
    this.webSock = new WebSocket(con.WS_URL(this.props.network));
    this.webSock.onmessage = (event) => {
      switch (event.type) {
        case "message":
          let e = JSON.parse(event.data);
          if (e.code === "init") {
            this.setState(
              produce((draft) => {
                draft.blocks = e.blocks;
                draft.recentBlocks = e.gBlocks;
                draft.txs =
                  e.transactions.length > 9
                    ? e.transactions.slice(0, 10)
                    : e.transactions;
              })
            );
          } else if (e.code === "header") {
            this.setState(
              produce((draft) => {
                draft.recentBlocks.unshift(e.block);
              })
            );
            this.getRecent();
            this.getTotalBalance();
            this.getTopRanks();
          }
          break;
        default:
          break;
      }
    };
    // 사용하지않음으로 주석처리
    // this.minerInterval = setInterval(this.getMiners, 180000);
    this.heartBeatInterval = setInterval(this.getHeartBeat, 30000);
  };

  closeWebSocket = () => {
    if (this.webSock !== undefined) {
      if (
        this.webSock.readyState === WebSocket.OPEN ||
        this.webSock.readyState === WebSocket.CONNECTING
      ) {
        this.webSock.close();
        clearInterval(this.minerInterval);
        clearInterval(this.heartBeatInterval);
      }
    }
  };

  componentDidMount() {
    this.getTopRanks();
    this.getTotalBalance();
    this.openWebSocket();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.network !== prevProps.network) {
      this.openWebSocket();
    }
    ReactTooltip.rebuild();
  }

  componentWillUnmount() {
    this.closeWebSocket();
  }

  render() {
    const { network } = this.props;
    const { recentBlocks, miners } = this.state;

    return (
      <Layout>
        <main className="mainView">
          <div className="l-wrapper">
            <div className="page_upper">
              <Search />
              <PageState pageName="AndUsChain Explorer" pageNetwork={network} />
            </div>
            <div className="main_contents_group">
              <div className="main_col blockTime">
                <div className="blockTime_wrapper">
                  <BlockTime network={network} gData={recentBlocks} />
                </div>
              </div>
              <div className="main_col blocks">
                <ContentsBox title="Top Accounts by DEB Balance">
                  <TopBalanceComponent
                    accountList={this.state.topRanks}
                    totalBalance={toFixed(this.state.totalBalance)}
                    totalAccounts={this.state.totalAccounts}
                    type="simple"
                  />
                  <div className="blocks_btn_area">
                    <Button link="/ranking">View All</Button>
                  </div>
                </ContentsBox>
              </div>
              <div className="main_col blocks">
                <ContentsBox title="Recent Blocks">
                  <BlocksComponent blocks={this.state.blocks} type="simple" />
                  <div className="blocks_btn_area">
                    <Button link="/blocks">View All</Button>
                  </div>
                </ContentsBox>
              </div>
              <div className="main_col transaction">
                <ContentsBox title="Recent Transactions">
                  <TransactionsComponent
                    transactions={this.state.txs}
                    type="simple"
                  />
                </ContentsBox>
              </div>
              <ReactTooltip />
            </div>
          </div>
        </main>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    network: state.appState.network,
  };
};

const mapDispatchToProps = (dispatch) => ({
  changeMainnet: bindActionCreators(mainnet, dispatch),
  changeTestnet: bindActionCreators(testnet, dispatch),
  changeDevnet: bindActionCreators(devnet, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Main);
